<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="群聊管理">
      <!-- <el-button
        icon="el-icon-plus"
        size="small"
        type="primary"
        @click="newlyAdded"
        >新增</el-button
      > -->
    </pageTitle>
    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div class="button button_revoke" @click="setSystem(row.row)">
            <i class="iconfont icon-bianji"></i> 设置
          </div>

          <div class="button button_revoke" @click="deleteRows(row.row)">
            <i class="iconfont icon-shanchu"></i> 删除
          </div>
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
  </div>
</template>
<script>
import {
  customerGetList,
  getshoplist,
  supplierGetList,
  userGetlist,
} from "@/api/basicConfiguration";
import { wechatRoomList, wechatRoomDelete } from "@/api/base";
const defaultParameters = {
  page: 1,
  limit: 10,
};
import { getRoles } from "@/utils";
export default {
  name: "groupChatManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
        isEdit: false,
      },
      basicListconfig: {
        operationWidth: "200px",
        loading: false,
        search: [
          {
            label: "群聊名称",
            type: "input",
            key: "room_name",
          },
          {
            label: "群类型",
            type: "select",
            key: "type",
            options: [
              {
                label: "外部群",
                value: 1,
              },
              {
                label: "内部群",
                value: 2,
              },
            ],
          },
          {
            label: "客户",
            key: "customer_id",
            type: "select",
            options: [],
          },
          {
            label: "供应商",
            key: "supplier_id",
            type: "select",
            options: [],
          },
          // {
          //   label: "商户",
          //   key: "comp_id",
          //   type: "select",
          //   options: [],
          // },
          {
            label: "店铺",
            key: "shop_id",
            type: "select",
            options: [],
          },
          {
            label: "业务员",
            key: "sale_user_id",
            type: "select",
            options: [],
          },
        ],
        data: [],
        column: [
          {
            label: "群聊ID",
            prop: "room_id",
          },
          {
            label: "群聊名称",
            prop: "room_name",
          },
          {
            label: "群聊类型",
            prop: "type_Text",
          },
          {
            label: "客户名称",
            prop: "customer_name",
          },
          {
            label: "供应商名称",
            prop: "supplier_name",
          },
          {
            label: "业务员",
            prop: "sale_name",
          },
          {
            label: "订单毛利",
            prop: "gross_margin_Text",
          },
          {
            label: "是否需要艾特",
            prop: "is_at_Text",
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    // 初始化列表内容
    this.getlist();
    this.getOptionalFields();
  },
  methods: {
    // 获取可取字段
    getOptionalFields() {
      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id + "",
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
      supplierGetList({
        limit: 10000,
        comp_id: this.$store.getters.userInfo.compId,
        is_showAll: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "supplier_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.id + "-" + item.nick_name,
                  value: item.id,
                };
              });
            }
            return item;
          });
        } else if (res.code == 0) {
          this.$message.error(res.data.msg || "获取供应商数据源失败！");
        }
      });
      customerGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "customer_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
      userGetlist({ limit: 10000, status: 0 }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "sale_user_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            }
            return item;
          });
        } else {
          this.$message.error(res.data.msg || "获取供应商数据源失败！");
        }
      });
    },
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.getlist();
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
      this.dialogParams.isEdit = false;
    },
    setSystem(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
      this.dialogParams.isEdit = true;
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        wechatRoomDelete({
          id: row.id,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      wechatRoomList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 200) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data.list.map((item) => {
            item.gross_margin_Text = item.gross_margin == 1 ? "不显示" : "显示";
            item.is_at_Text = item.is_at == 1 ? "不需要" : "需要";
            item.type_Text = item.type == 1 ? "外部群" : "内部群";
            return item;
          });
          this.basicListconfig.total = res.data.total;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/groupChatManagement/index.vue